import { createAction, props } from '@ngrx/store';

export const changePageSizeValue = createAction('[PageSize] Change Value', props<{ value: string | number }>());
